module.exports = __webpack_public_path__ + "static/media/pendingRequestIcon.0f638d90.svg";